import { useCallback } from 'react';
import { message } from 'antd';
import { t } from '../../../../i18n';
import { useCurrentUserOperableWarehouseIds } from '../../../../hooks/useCurrentUserOperableWarehouseIds';

/**
 * 用 waypointId（即该途经点所在仓库的ID）校验登录账号是否有权限操作该仓，
 * 权限数据源为 useCurrentUserOperableWarehouseIds（与 useCurrentUserOperableHubs 同源，仅返回 ID 列表）。
 * waypointId 为 -1 时跳过校验（视为无需判断仓库归属的场景）。
 * 不通过时提示「没有该仓的操作权限」，不进入编辑态；不修改 useEditToolbar/EditToolbar 本身，
 * 仅用于任务详情抽屉里「司机到达/解封车/卸车/装车/封车/发车」这几个步骤详情组件。
 */
export function useWarehousePermissionGuardedStartEdit(waypointId: number | string, startEdit: () => void): () => void {
    const { warehouseIds, hasFullWarehouseAccess } = useCurrentUserOperableWarehouseIds();
    // GraphQL Long/ID 常序列化为字符串，与 useCurrentUserOperableWarehouseIds 已归一化的 number[] 比较前需统一转为 number
    const normalizedWaypointId = Number(waypointId);

    return useCallback(() => {
        const hasPermission =
            normalizedWaypointId === -1 ||
            hasFullWarehouseAccess ||
            warehouseIds.some((warehouseId) => warehouseId === normalizedWaypointId);
        // eslint-disable-next-line no-console
        console.log('[WarehousePermissionGuard] 点击编辑触发校验', { waypointId: normalizedWaypointId, warehouseIds, hasFullWarehouseAccess, hasPermission });
        if (!hasPermission) {
            message.warning(t('errors.permission.warehousePermissionDenied'));
            return;
        }
        startEdit();
    }, [warehouseIds, hasFullWarehouseAccess, normalizedWaypointId, startEdit]);
}
